export default {
    stringToFloat(input?: string | number): number | undefined {
        if (!input) {
            return 0;
        }

        if (typeof input === 'number') {
            return input;
        }

        return parseFloat(input.replace(/,/, '.'));
    },
};
